type MoneyInput = number | string | null | undefined;

/**
 * PayPal Orders v2 rejects currency amounts that are not strings with exactly
 * two decimal places. Binary float sums stringify with extra digits.
 */
export function formatPayPalAmount(price: MoneyInput = 0): string {
    return centsToAmount(toCents(price));
}

export function buildPayPalCheckoutAmount(parts: {
    itemTotal: MoneyInput;
    shipping: MoneyInput;
    tax: MoneyInput;
}) {
    const shippingCents = toCents(parts.shipping);
    const taxCents = toCents(parts.tax);
    let orderCents = toCents(
        Number(parts.itemTotal ?? 0) + Number(parts.shipping ?? 0) + Number(parts.tax ?? 0)
    );
    let itemCents = orderCents - shippingCents - taxCents;

    if (itemCents < 0) {
        itemCents = toCents(parts.itemTotal);
        orderCents = itemCents + shippingCents + taxCents;
    }

    return {
        currency_code: "USD" as const,
        value: centsToAmount(orderCents),
        breakdown: {
            item_total: { currency_code: "USD" as const, value: centsToAmount(itemCents) },
            shipping: { currency_code: "USD" as const, value: centsToAmount(shippingCents) },
            tax_total: { currency_code: "USD" as const, value: centsToAmount(taxCents) },
        },
    };
}

function toCents(price: MoneyInput): number {
    const amount = Number(price ?? 0);
    if (!Number.isFinite(amount)) {
        return 0;
    }

    return Math.round(amount * 100);
}

function centsToAmount(cents: number): string {
    return (cents / 100).toFixed(2);
}
